import { Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ProductCriteria } from '@app/dao/product/product.dao';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import * as _ from 'lodash';
import { Subject, map } from 'rxjs';
import { EaSimulationAvFormBuilder } from './ea-simulation-av-form.builder';

@Component({
    selector: 'ea-simulation-av-form',
    templateUrl: './ea-simulation-av-form.component.html',
    styleUrls: ['./ea-simulation-av-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationAvFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationAvFormComponent
  extends EaSimulationAvFormBuilder
  implements OnInit, OnDestroy
{
  productCriteria: ProductCriteria = {
    page: 0,
    size: 10,
    distinct: true,
    sorts: [
      {
        direction: 'ASC',
        property: 'NAME',
      },
    ],
    enabled: true,
    status: 'VALID',
    categories: ['FINANCIAL'],
    type: ['ASSURANCE_VIE'],
  };

  doneSubject: Subject<void> = new Subject<void>();
  alive = true;
  $packs;
  products: any[];

  constructor(
    protected formConstructor: PrFormConstructor,
    protected simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.$packs = this.simulationDao.getProductReference('ASSURANCE_VIE').pipe(
      map(products =>
        _(products)
          .orderBy(p => p.name.toLowerCase(), ['asc'])
          .value(),
      ),
    );
  }

  onSubmit() {
    this.derrors = true;

    // stop here if form is invalid
    if (this.form.invalid) {
      return;
    }

    this.prFormService.loading();
    this.prFormService.loaded();
    this.doneSubject.next(this.extract());

    if (this.callback) this.callback(this.extract());
  }

  ngOnDestroy(): void {
    this.alive = false;
  }
}
